import { stringHelpers } from '@approvalmax/utils';
import { constants, selectors } from 'modules/common';
import { z } from 'zod';

import { messages } from './XeroDeliveryDetailsSection.messages';

const { xeroConstants } = constants;

const removeInvalidChars = (value: string) => {
    return stringHelpers.escapeSpecificExpressions(value.trim(), xeroConstants.XERO_NOT_ALLOWED_SYMBOLS);
};

const validateMaxLength = (maxLength: number) => {
    return z.string().max(maxLength, messages.fieldMaxLength({ maxLength }));
};

const validateNotOnlySpaces = {
    validator: (val: string) => !val.length || val.trim().length,
    message: { message: messages.fieldSpacesOnly },
};

export const createSchema = (isAddressRequired: boolean) => {
    return z.object({
        address: validateMaxLength(xeroConstants.DELIVERY_ADDRESS_MAX_LENGTH)
            .min(isAddressRequired ? 1 : 0, messages.fieldRequired)
            .refine(validateNotOnlySpaces.validator, validateNotOnlySpaces.message)
            .transform(removeInvalidChars),

        attentionTo: validateMaxLength(xeroConstants.DELIVERY_ATTENTION_TO_MAX_LENGTH).refine(
            validateNotOnlySpaces.validator,
            validateNotOnlySpaces.message
        ),

        phone: validateMaxLength(xeroConstants.DELIVERY_PHONE_MAX_LENGTH)
            .refine(validateNotOnlySpaces.validator, validateNotOnlySpaces.message)
            .refine((value) => selectors.ui.isValidPhone(value), { message: messages.phoneInvalidFormat })
            .transform(removeInvalidChars),

        instructions: validateMaxLength(xeroConstants.DELIVERY_INSTRUCTIONS_MAX_LENGTH)
            .refine(validateNotOnlySpaces.validator, validateNotOnlySpaces.message)
            .transform(removeInvalidChars),
    });
};
